import React from "react"

export const VerveLogoText = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 469.38 94.75" alt="verve">
            <defs>
            <style>{"svg{width: 100%;max-height: 2rem;fill: inherit;}"}</style>
            </defs>
            <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path
                className="cls-1"
                d="M40.61,74.54,71.87,1.91h8.77L40.41,94.75,0,1.91H8.77Z"
                />
                <path
                className="cls-1"
                d="M226.52,13.35h.38C230.33,5.34,236.61,0,246,0a22.38,22.38,0,0,1,9.34,2.1l-4.58,7.63A11.75,11.75,0,0,0,244.62,8c-19.25,0-18.1,24-18.1,37V90h-8.59V1.91h8.59Z"
                />
                <path
                className="cls-1"
                d="M321.33,74.54,352.59,1.91h8.77L321.14,94.75,280.72,1.91h8.77Z"
                />
                <path
                className="cls-1"
                d="M392.93,46.71C392.36,69,407.8,83.89,428.2,83.89c13.73,0,24.78-8.2,31.07-20l7.24,4.19c-8,15.25-22.11,23.84-39.45,23.84-26.12,0-42.71-21.17-42.71-46.14,0-24.59,17-45.76,42.71-45.76,26.69,0,42.5,21.36,42.32,46.71Zm67.87-8C458.7,22.5,445.36,8,427.25,8c-17.92,0-32.79,14.11-34.32,30.7Z"
                />
                <path
                className="cls-1"
                d="M177.5,66.56c-7.27,11.25-19,18.48-32.66,17.32a37.75,37.75,0,0,1-11.52-2.94L168.4,15.73l.07,0,4-7.35A41,41,0,0,0,150.8.2c-25.64-2.18-44.34,17.47-46.42,42C102.26,67.06,117,89.55,143,91.76c17.29,1.47,32.07-5.89,41.34-20.41ZM113.72,36.33c2.88-13.66,15.11-30.8,36.6-28.13a31.3,31.3,0,0,1,11.24,3.29l-35,65.72C116.83,70.23,109.94,56.6,113.72,36.33Z"
                />
            </g>
            </g>
        </svg>
    )
}